<template>
  <documents-metadata
    :fetch-metadata-and-field-infos="getReadOnlyWorkspaceDocumentMetadata"
    :can-edit-metadata="false"
  />
</template>

<script setup lang="ts">
  import { useToast } from '@/composables/useToast';
  import { getWorkspaceDocumentDetailEndpoints } from '@/helpers';
  import axios from 'axios';
  import { IWorkspaceDocumentMetadataResponseDto } from 'types';
  import { useI18n } from 'vue-i18n';
  import DocumentsMetadata from './DocumentsMetadata.vue';
  import {
    DocumentsMetadataResponse,
    FetchMetadataFunction,
  } from './DocumentsMetadata.types';

  const props = defineProps<{
    workspaceId: string;
    documentId: string;
  }>();

  const emit = defineEmits<{
    (e: 'metadata-loaded', metadata: DocumentsMetadataResponse): void;
  }>();

  const { t } = useI18n();
  const { createErrorToast } = useToast();

  const getReadOnlyWorkspaceDocumentMetadata: FetchMetadataFunction =
    async () => {
      try {
        const response = await axios.get<IWorkspaceDocumentMetadataResponseDto>(
          getWorkspaceDocumentDetailEndpoints(
            'readOnly',
            props.workspaceId,
            props.documentId,
          ).metadata,
        );
        emit('metadata-loaded', response.data);
        return response.data;
      } catch (error) {
        createErrorToast(t('errors.error'));
        throw error;
      }
    };
</script>
